// src/api/siteNavApi.js

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/**
 * Legge le voci header/footer allineate dal sito www.stirup.it.
 *
 * Endpoint PUBBLICO (nessun token). L'app NON fetcha mai www.stirup.it:
 * legge solo questo endpoint, popolato dal "pulsante di allineamento" admin.
 *
 * Risposta:
 *   {
 *     header: [{ label, url }],
 *     footer: { columns: [{ title, items: [{ label, url }] }], social: [{ platform, url }], copy },
 *     last_synced_at: string | null
 *   }
 */
export async function fetchSiteNav({ signal } = {}) {
  const res = await fetch(`${API_BASE}/api/ui/site-nav`, { signal });
  if (!res.ok) throw new Error(`site-nav fetch failed: ${res.status}`);
  return res.json();
}

export default fetchSiteNav;
